import { Api } from "../../../api/api";
import { retrieveMarketCapData } from "./retrieveMarketCapData";

const createNewChart = (consolidatedList, stockId) => {
  consolidatedList[stockId] = {
    name: stockId,
    marketCap: retrieveMarketCapData(stockId),
    charts: [],
  };
};

const consolidateList = (charts) => {
  const consolidatedList = {};
  charts.forEach((chart) => {
    const { stock_id } = chart;
    const consolidatedChart = consolidatedList[stock_id];

    if (!consolidatedChart) {
      createNewChart(consolidatedList, stock_id);
    }
    consolidatedList[stock_id].charts.push(chart);
  });
  return Object.values(consolidatedList);
};

export const getCollectionChartList = async (id) => {
  try {
    const { charts } = await Api.getChartCollection(id);

    //the returned list may have multiple charts for the same stock id
    //as some assets have several intervals.
    //we will consolidate these charts and store the different intervals as a property
    return consolidateList(charts);
  } catch (e) {}
};
